<template>
	<form @submit.prevent="submit">
		<div
			v-if="message"
			class="notification is-light"
			:class="messageType"
			data-test="error-notification"
		>
			{{ message }}
		</div>
		<required-field
			:error="$v.email.$error"
			:required="$v.email.required"
			label="Email"
		>
			<input
				v-model.trim="$v.email.$model"
				class="input"
				type="text"
				:class="{ 'is-danger': $v.email.$error }"
				data-test="email"
			/>
			<p
				v-if="!$v.email.email"
				class="help is-danger"
				data-test="email-validation"
			>
				We require a valid email address
			</p>
		</required-field>
		<required-field
			:error="$v.password.$error"
			:required="$v.password.required"
			label="Password"
		>
			<input
				v-model.trim="$v.password.$model"
				class="input"
				type="password"
				:class="{ 'is-danger': $v.password.$error }"
				data-test="password"
			/>
			<p
				v-if="!$v.password.minLength"
				class="help is-danger"
				data-test="password-validation"
			>
				Password must have at least {{ $v.password.$params.minLength.min }}
			</p>
		</required-field>
		<div class="buttons mt-5">
			<button
				class="button is-success is-fullwidth"
				:class="{ 'is-loading': fetching }"
				:disabled="!isValid"
				data-test="submit"
			>
				Log in
			</button>
		</div>
	</form>
</template>

<script>
import formMixin from "./formMixins";
import { required, minLength, email } from "vuelidate/lib/validators";

export default {
	name: "FormLogin",
	mixins: [formMixin],
	validations: {
		email: { required, email },
		password: { required, minLength: minLength(8) }
	},
	data() {
		return {
			email: "",
			password: ""
		};
	},
	methods: {
		submit() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				const data = { email: this.email, password: this.password };
				this.$emit("submit", data);
			}
		}
	}
};
</script>

<style scoped>
form {
	margin-bottom: 1.5rem;
}
</style>
